function PaymentAnalysis({paymentAnalysis = [], paymentAnalysisTotal = {}}){
    return (
        <div className="card">
            <div className="card-body">
                <div>
                    <h5>Top regions by revenue</h5>
                    <p className="fs-9">Where you generated most of the revenue</p>
                </div>
                <div className="scrollbar">
                    <table className="fs-10 mb-0 border-top border-translucent scrollbar table">
                        <thead>
                        <tr>
                            <th className="sort ps-0" style={{ width: "32%" }}>COUNTRY</th>
                            <th className="sort" style={{ width: "20%" }}>USERS</th>
                            <th className="sort text-end align-middle" style={{ width: "13%" }}>TRANSACTIONS</th>
                            <th className="sort text-end align-middle" style={{ width: "20%" }}>REVENUE</th>
                            <th className="sort text-end align-middle pe-0" style={{ width: "17%" }}>CONV. RATE</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td></td>
                            <td className="py-4"><h4 className="mb-0 fw-normal">{paymentAnalysisTotal.AllUsers}</h4></td>
                            <td className="text-end py-4"><h4 className="mb-0 fw-normal">{paymentAnalysisTotal.AllTransactions}</h4></td>
                            <td className="text-end py-4"><h4 className="mb-0 fw-normal">${paymentAnalysisTotal.AllPayment}</h4></td>
                            <td className="text-end py-4 pe-0"><h4 className="mb-0 fw-normal">{paymentAnalysisTotal.TotalConv}%</h4></td>
                        </tr>
                        {
                            paymentAnalysis.map((item, index) => (
                                <tr key={index}>
                                    <td className="white-space-nowrap align-middle ps-0">
                                        <div className="d-flex align-items-center"><h6 className="mb-0 me-3">1.</h6>
                                            <div data-discover="true">
                                                <div className="d-flex justify-content-center align-items-center">
                                                    <img alt="" width="24" src={`https://flagsapi.com/${item.CountryCode}/flat/32.png`}/>
                                                    <p className="mb-0 ps-3 text-primary fw-bold fs-9">{item.Location}</p></div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="align-middle">
                                        <div className='d-flex align-items-center'>
                                            <h6 className="mb-0 me-1">{item.TotalUsers}</h6>
                                            <span className="fs-10 badge-bt badge-bt-danger badge">({item.UsersPercent}%)</span>
                                        </div>
                                    </td>
                                    <td className="align-middle">
                                        <div className='d-flex align-items-center justify-content-end'>
                                            <h6 className="mb-0 me-1">{item.Transactions}</h6>
                                            <span className="fs-10 badge-bt badge-bt-danger badge">({item.TransactionsPercent}%)</span>
                                        </div>
                                    </td>
                                    <td className="align-middle">
                                        <div className='d-flex align-items-center justify-content-end'>
                                            <h6 className="mb-0 me-1">{item.TotalPayment}</h6>
                                            <span className="fs-10 badge-bt badge-bt-danger badge">({item.PaymentPercent}%)</span>
                                        </div>
                                    </td>
                                    <td className="text-end pe-0 align-middle">
                                        <h6 className="mb-0">{item.ConversionRate}%</h6>
                                    </td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default PaymentAnalysis;